<template>
  <div :class="$style.college">
    <h2 id="js-college-title" :class="$style.title">
      <span class="app-fadeInUp">极致学院</span>
    </h2>
    <div id="js-college-content" :class="$style.content">
      <div class="app-fadeInUp">
        <p>
          为了提升公司员工能力，发掘、陪伴、成就优秀人才，极致学院氤氲而生。极致学院建立了完善的学习管理体系，针对不同职能和层级的同学制定相应的课程体系，为每一个同学搭建学习分享平台。
        </p>
        <p>
          社招新员工：入职培训搭配导师1对1辅导，制定试用期培养计划，提升专业能力，快速上手工作。
        </p>
        <p>
          校招新同学：导师1对1全程辅导，入职前，由线上远程辅导；入职后，系列课程帮助新同学从校园到职场全方位提升。
        </p>
        <a :href="system.job && system.job.url" target="_blank">
          加入极致 &rarr;
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import fadeMixins from '@/assets/js/fadeMixins'

export default {
  mixins: [fadeMixins],
  data() {
    return {
      name: 'college',
      animateScenesData: ['title', 'content'],
    }
  },
  computed: {
    ...mapGetters(['system']),
  },
}
</script>

<style lang="less" module>
.college {
  position: relative;
  z-index: 1;
  min-height: 4.79rem;
  padding: @padding-base 0 @padding-base 3.6rem;
  background: url('./images/college-illus.png') no-repeat 9.58rem
    @padding-base-title;
  background-size: 7.36rem 3.93rem;
  box-sizing: border-box;

  @media screen and (max-width: @laptop-width) {
    background-position: 9.58rem center;
  }

  @media screen and (max-width: @tablet-width) {
    padding-left: 2.6rem;
  }

  @media screen and (max-width: @mini-width) {
    background: none;
    padding-left: 1.3rem;
    padding-right: 1.3rem;
  }
}

.title {
  span {
    .subtitle-size(2.88rem, 0.61rem);
    .text-hide();
    display: block;
    background: url('./images/college-title.png') no-repeat;
    background-size: 100% 100%;
  }
}

.content {
  width: 5.54rem;
  margin-top: 0.76rem;
  color: #3f3f3f;
  line-height: 2.2;

  @media screen and (max-width: @tablet-width) {
    width: 7rem;
  }

  @media screen and (max-width: @mini-width) {
    width: auto;
  }

  a {
    display: inline-block;
    margin-top: 0.45rem;
    padding: 0 1.5em;
    border: 0.02rem solid #818181;
    border-radius: 1rem;
    background-color: #fff;
    font-size: 12px;
    line-height: 2;
    color: #3f3f3f;
    text-align: center;
    text-decoration: none;

    &:hover {
      border-color: #f3f3f3;
      background-color: #f3f3f3;
    }
  }
}
</style>
